let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6guFg")).then(() => parcelRequire('BAU7q'));